<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'
import { useCache } from '@/hooks/web/useCache'


//weixin

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

const { wsCache } = useCache()

const normalizeIsDark = (value: unknown) => value === true || value === 'true' || value === 1 || value === '1'

// 默认固定浅色。只有用户通过主题开关显式选择后，才读取本地暗色缓存。
const setDefaultTheme = () => {
  const cachedIsDark = wsCache.get('isDark')
  if (wsCache.get('isDarkUserSetting') !== null && cachedIsDark !== null) {
    appStore.setIsDark(normalizeIsDark(cachedIsDark), false)
    return
  }
  wsCache.delete('isDark')
  appStore.setIsDark(false, false)
}

setDefaultTheme()
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}
 
html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}
.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
